module.exports = __webpack_public_path__ + "fonts/CashSans-ExtblackItl.18fea00.woff2";